/**
 * ERC Pin-to-Pin Validator Adapter for DRC System
 *
 * This validator checks for incompatible pin connections on the same net.
 *
 * Feature-gated via DrcEnabledCheckers.ErcPinToPinValidator
 */
import { ReviewType } from "@buildwithflux/models";
import { getProblemTypeKeyFromReviewType } from "../../drc/types";
import { getPinCompatibility, getPinTypeName } from "../pinTypes";
import { ErcSeverity } from "../types";
import { getPinsForNet, createErcProblem, formatPinReference } from "./ercUtils";
/**
 * Validator that checks for incompatible pin-to-pin connections.
 */
export class ErcPinToPinValidator {
    reviewType = ReviewType.DesignRuleCheckErcPinToPin;
    problemTypeKey = getProblemTypeKeyFromReviewType(this.reviewType);
    defaultHidden = false;
    async checkForProblems(inputs) {
        const foundProblems = [];
        for (const [netHash, terminals] of Object.entries(inputs.netMap)) {
            const pins = getPinsForNet(inputs, terminals);
            if (pins.length < 2) {
                continue;
            }
            // Compare all pairs of pins
            for (let i = 0; i < pins.length; i++) {
                for (let j = i + 1; j < pins.length; j++) {
                    const pin1 = pins[i];
                    const pin2 = pins[j];
                    if (!pin1 || !pin2)
                        continue;
                    const severity = getPinCompatibility(pin1.pinType, pin2.pinType);
                    if (severity !== ErcSeverity.OK) {
                        const type1Name = getPinTypeName(pin1.pinType);
                        const type2Name = getPinTypeName(pin2.pinType);
                        const message = `Incompatible pin types on net. ` +
                            `${formatPinReference(pin1)} (${type1Name}) connected to ` +
                            `${formatPinReference(pin2)} (${type2Name}).`;
                        foundProblems.push(createErcProblem(this.problemTypeKey, `${this.problemTypeKey}_${netHash}_${pin1.terminalUid}_${pin2.terminalUid}`, message, [pin1.elementUid, pin2.elementUid], [formatPinReference(pin1), formatPinReference(pin2)], severity));
                    }
                }
            }
        }
        return {
            error: false,
            problemTypeKey: this.problemTypeKey,
            foundProblems,
        };
    }
}
//# sourceMappingURL=ErcPinToPinValidator.js.map